<div class="dictionary-background">
  <div class="dictionary-heading">
    {{ 'dictionary.header' | translate}}
  </div>

  <div class="dictionary-container ">
    @for (dropdownData of dictionary; track $index) {
      <div class="dictionary-dropdown-container">
        <libero-dictionary-dropdown [dropdownInput]="dropdownData"></libero-dictionary-dropdown>
      </div>
    }
  </div>
</div>